import React, { useEffect, useState, useMemo } from "react";
import moment from "moment";
import Container from "@material-ui/core/Container";
import { Button, Grid, Tooltip } from "@material-ui/core";
import ColAtm from "../../../../atomic/Col/Col";
import BlockAtm from "../../../../atomic/Block/Block";
import LabelAtm from "../../../../atomic/Label/Label";
import ButtonAtm from "../../../../atomic/Button/Button";
import InventorySkeleton from "../../../../molecules/InventorySkeleton/InventorySkeleton";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAppLang, getCurrency, getProperty, isDefined } from "../../../../../utils";
import { DOWNLOAD_CPA_EXCEL } from "../../../../../constants/api.constants";
import axios from "axios";
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { getCpaDailyPrice, getCpaPromotionAvailable } from "../../../../../redux/actions/Network/Inventory/CompetitorActions";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { BEST_AVAILABLE_PRICE, AI_COMPETITOR_ANALYSIS, CPA_PROMOTION_AVAILABLE, LIST_PROPERTY } from "../../../../../constants/api.constants";
import { getPropertyList } from "../../../../../redux/actions/propertyActions";
import Divider from "@material-ui/core/Divider";
import {FormControl, Select, InputLabel, MenuItem, Box} from "@material-ui/core";
import { Chart as ChartJS, CategoryScale, LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  Legend,
} from "chart.js";
import { Line } from 'react-chartjs-2';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  Legend
);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    fabProgress: {
        color: green[500],
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

const CompetitorAnalysisAdvanced = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const classes = useStyles();

    const { getCpa, fetching } = useSelector(props => props?.cpaReducer);

    const { cpaGroup, cpaGroupFetching, selectedGroupId, onGroupFilterChange, cpaGroupMappingFetching } = props;

    const extranetworkCompetitors = useMemo(() => {
        if (!getCpa || !Array.isArray(getCpa)) return [];
        return getCpa.filter(c => c.competitor_property_source === "extranetwork");
    }, [getCpa]);

    const getPropertyListData = props?.propertyList;

    const { prices, loading, error, cpaPromotionAvailable, cpaPromotionAvailableFetching, cpaPromotionAvailableError } = useSelector((state) => state.cpaReducer);

    const currentPropertyId = parseInt(getProperty());

    // Grup filtreleme prop'u
    const groupFilteredHotelKeys = props.groupFilteredHotelKeys;

    const propertyList = useMemo(() => {
        let extranetworkKeys = extranetworkCompetitors.map(c => parseInt(c?.key));

        // Grup filtresi YOKSA: sadece extranetwork otelleri göster (eski davranış)
        if (groupFilteredHotelKeys === null || groupFilteredHotelKeys === undefined) {
            const list = Array.isArray(props?.propertyList) ? 
                props.propertyList.filter(p => extranetworkKeys.includes(p?.id)) : [];
            
            const currentIndex = list.findIndex(p => p?.id === currentPropertyId);
            if (currentIndex > 0) {
                const [currentProperty] = list.splice(currentIndex, 1);
                list.unshift(currentProperty);
            }
            return list;
        }

        // Grup filtresi VARSA: groupFilteredHotelKeys'teki tüm key'leri işle
        // Her key için önce getCpa'dan, sonra propertyList'ten ara
        const list = groupFilteredHotelKeys.map(keyStr => {
            // 1. getCpa'da bu key'e sahip hotel var mı?
            const cpaHotel = (getCpa || []).find(c => String(c.key) === keyStr);
            
            if (cpaHotel) {
                // getCpa'da bulundu
                if (cpaHotel.competitor_property_source === "extranetwork") {
                    // propertyList'ten zengin veriyi bul
                    const propertyData = (props?.propertyList || []).find(p => String(p?.id) === keyStr);
                    if (propertyData) {
                        return {
                            ...propertyData,
                            _source: "extranetwork",
                            _cpaKey: keyStr,
                        };
                    }
                }
                // Non-extranetwork veya propertyList'te bulunamayan: getCpa verisini kullan
                return {
                    id: cpaHotel.key,
                    name: cpaHotel.name,
                    default_photo: cpaHotel.image || cpaHotel.photo || null,
                    _source: cpaHotel.competitor_property_source,
                    _cpaKey: keyStr,
                };
            }

            // 2. getCpa'da yok, propertyList'te ara (extranetwork olarak)
            const propertyData = (props?.propertyList || []).find(p => String(p?.id) === keyStr);
            if (propertyData) {
                return {
                    ...propertyData,
                    _source: "extranetwork",
                    _cpaKey: keyStr,
                };
            }

            // 3. Hiçbir yerde bulunamadı - yine de göster (key bilgisiyle)
            return {
                id: keyStr,
                name: `Hotel (${keyStr})`,
                default_photo: null,
                _source: "unknown",
                _cpaKey: keyStr,
            };
        }).filter(Boolean);

        return list;
    }, [props?.propertyList, currentPropertyId, extranetworkCompetitors, groupFilteredHotelKeys, getCpa]);

    const lsAllDays = JSON.parse(localStorage.getItem("allDays"));

    const [modalOpen, setModalOpen] = useState(false);
    const [modalList, setModalList] = useState([]);
    const [modalProvider, setModalProvider] = useState('');
    const [modalAmount, setModalAmount] = useState('');
    const [modalCurrency, setModalCurrency] = useState('');
    const selectedProvider = props.selectedProvider || "";
    const [excelUrl, setExcelUrl] = useState("");
    const [disableExcelBtn, setDisableExcelBtn] = useState(false);
    const [allProviders, setAllProviders] = useState([]);
    const [openedHotelKey, setOpenedHotelKey] = useState(null);
    const [subProviders, setSubProviders] = useState('');
    const currency = props?.currency;

    const [currentPropertyPrices, setCurrentPropertyPrices] = useState(props?.currentPropertyPrices);
    const [currentPropertyInfo, setCurrentPropertyInfo] = useState(props?.currentPropertyInfo);
    const [getBestAvailableRate, setGetBestAvailableRate] = useState(localStorage.getItem("getBestAvailableRate") === "true");

    const [propertyBestPrices, setPropertyBestPrices] = useState({});
    const [promotionData, setPromotionData] = useState({});

    const cpaPromotions = cpaPromotionAvailable;

    const getPriceForProviderFilter = (hotelId, date) => {
        const key = `${hotelId}_${date}`;
        const priceObj = prices[key];
        if (!priceObj) return { amount: null, provider: null, currency: null };

        if (selectedProvider) {
            if (Array.isArray(priceObj.all)) {
                const found = priceObj.all.find(
                    p => p.provider && p.provider.trim().toLowerCase() === selectedProvider.trim().toLowerCase()
                );
                if (found) {
                    return { amount: found.amount, provider: found.provider, currency: found.currencyCode || priceObj.currency };
                }
            }
            if (priceObj.provider && priceObj.provider.trim().toLowerCase() === selectedProvider.trim().toLowerCase()) {
                return { amount: priceObj.amount, provider: priceObj.provider, currency: priceObj.currency };
            }
            return { amount: null, provider: null, currency: null };
        }

        return { amount: priceObj.amount, provider: priceObj.provider, currency: priceObj.currency };
    };

    useEffect(() => {
        setCurrentPropertyInfo(props.currentPropertyInfo)
    }, [props.currentPropertyInfo]);

    useEffect(() => {
        setCurrentPropertyPrices(props.currentPropertyPrices)
    }, [props.currentPropertyPrices]);

    const getUserProperty = () => {
        const lsAllDays = JSON.parse(localStorage.getItem("allDays"));
        if (!lsAllDays || lsAllDays.length === 0) return;

        const requests = lsAllDays.map(date => {
            const params = {
                params: {
                    type: "date",
                    property_id: getProperty(),
                    date: date,
                    currency: "EUR"
                }
            };
            return axios.post(BEST_AVAILABLE_PRICE, params, {
                headers: {
                    "Accept": "application/json",
                    authToken: localStorage.getItem('auth'),
                    "Content-Type": "application/json",
                    "language": getAppLang(),
                }
            }).then(result => result.data.data).catch(() => null);
        });

        Promise.all(requests).then(results => {
            let mergedCurrency = "EUR";
            const mergedDates = {};
            results.forEach(data => {
                if (data && data.date && typeof data.date === "object") {
                    if (data.currency) mergedCurrency = data.currency;
                    Object.entries(data.date).forEach(([dateKey, obj]) => {
                        mergedDates[dateKey] = obj;
                    });
                }
            });

            setCurrentPropertyInfo({
                name: props?.propertyName,
                key: "property-" + getProperty(),
                currency: mergedCurrency,
            });

            const pricesObj = {};
            Object.entries(mergedDates).forEach(([date, obj]) => {
                pricesObj[`${"property-"}${getProperty()}_${date}`] = {
                    amount: obj.rate,
                    currency: mergedCurrency,
                    provider: "",
                };
            });

            setCurrentPropertyPrices(pricesObj);
            setGetBestAvailableRate(true);
            localStorage.setItem("getBestAvailableRate", "true");
        }).catch(function (error) {
            console.log(error);
            setGetBestAvailableRate(false);
            localStorage.setItem("getBestAvailableRate", "false");
        });
    }

    useEffect(() => {
        if (props.getBestAvailableRate) {
            props.getBestAvailableRate(getBestAvailableRate);
        }
    }, [getBestAvailableRate]);
    
    const downloadExcel = () => {
        const url = DOWNLOAD_CPA_EXCEL;

        if (excelUrl === "") {
            setDisableExcelBtn(true)
        }

        const data = ({
            params: {
                property_id: getProperty(),
                start_date: lsAllDays[0],
                finish_date: lsAllDays[lsAllDays.length - 1],
                currency: currency ?? getCurrency()
            }
        });
        axios.post(url, data, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            setExcelUrl(result.data.data.url)
            setDisableExcelBtn(false)
        }).catch(function (error) {
            console.log(error);
        });
    }

    useEffect(() => {
        if (excelUrl !== "") {
            window.open(excelUrl)
        }
        setExcelUrl("")
        setDisableExcelBtn(false)
    }, [excelUrl])

    const fetchPropertyBestPrices = () => {
        if (!propertyList || propertyList.length === 0 || !lsAllDays || lsAllDays.length === 0) return;

        const allRequests = [];

        propertyList.forEach(property => {
            lsAllDays.forEach(date => {
                const params = {
                    params: {
                        type: "date",
                        property_id: property.id,
                        date: date,
                        currency: "EUR"
                    }
                };
                const request = axios.post(BEST_AVAILABLE_PRICE, params, {
                    headers: {
                        "Accept": "application/json",
                        authToken: localStorage.getItem('auth'),
                        "Content-Type": "application/json",
                        "language": getAppLang(),
                    }
                }).then(result => {
                    const data = result?.data?.data;
                    if (data && data.date && typeof data.date === "object") {
                        const entries = Object.entries(data.date);
                        return entries.map(([dateKey, obj]) => ({
                            key: `${property.id}_${dateKey}`,
                            rate: obj.rate,
                            currency: data.currency,
                            available: obj.available
                        }));
                    }
                    return [];
                }).catch(() => []);

                allRequests.push(request);
            });
        });

        Promise.all(allRequests).then(results => {
            const merged = {};
            results.flat().forEach(item => {
                if (item && item.key) {
                    merged[item.key] = {
                        rate: item.rate,
                        currency: item.currency,
                        available: item.available
                    };
                }
            });
            setPropertyBestPrices(prev => ({ ...prev, ...merged }));
        });
    };

    // Her property ve tarih için promotion verilerini çek
    const fetchPromotionData = () => {
        if (!propertyList || propertyList.length === 0 || !lsAllDays || lsAllDays.length === 0) return;

        const allRequests = [];

        propertyList.forEach(property => {
            lsAllDays.forEach(date => {
                const request = axios.post(CPA_PROMOTION_AVAILABLE, {
                    params: {
                        property_id: property.id,
                        date: date
                    }
                }, {
                    headers: {
                        "Accept": "application/json",
                        authToken: localStorage.getItem('auth'),
                        "Content-Type": "application/json",
                        "language": getAppLang(),
                    }
                }).then(result => {
                    const data = result?.data?.data;
                    return {
                        key: `${property.id}_${date}`,
                        data: data || null
                    };
                }).catch(() => ({
                    key: `${property.id}_${date}`,
                    data: null
                }));

                allRequests.push(request);
            });
        });

        Promise.all(allRequests).then(results => {
            const merged = {};
            results.forEach(item => {
                if (item && item.key && item.data) {
                    merged[item.key] = item.data;
                }
            });
            // console.log('All promotion data keys:', Object.keys(merged));
            // console.log('All promotion data:', merged);
            setPromotionData(merged);
        });
    };

    useEffect(() => {
        if (props.trigger) {
            lsAllDays.map((date) => {
                propertyList.forEach((property) => {
                    // Grup filtreli non-extranetwork oteller için key ile çek, extranetwork için property.id ile çek
                    if (property._source && property._source !== "extranetwork") {
                        // tripadvisor gibi kaynaklar: key ile fiyat çek, property_id null
                        dispatch(getCpaDailyPrice(date, property._cpaKey, 'EUR', null));
                    } else {
                        dispatch(getCpaDailyPrice(date, null, 'EUR', property.id));
                    }
                });
            });
            getUserProperty();
            fetchPropertyBestPrices();
            fetchPromotionData();
        }
    }, [props.trigger]);

    useEffect(() => {
        if (props.downloadExcel) {
            downloadExcel();
        }
    }, [props.downloadExcel]);

    const openModal = (e, key, selectedSubProvider) => {
        e.stopPropagation();
        const priceObj = prices[key];
        if (!priceObj) return;

        const provider = priceObj.provider;
        const amount = priceObj.amount;
        const priceCurrency = priceObj.currency;

        let sortedList = [];
        if (Array.isArray(priceObj.all)) {
            sortedList = [
                ...priceObj.all.filter(item => item.provider === provider).map(item => ({...item})),
                ...priceObj.all.filter(item => item.provider !== provider).map(item => ({...item}))
            ];
        }

        const underscoreIdx = key.indexOf('_');
        const modalHotelId = key.substring(0, underscoreIdx);
        const modalDate = key.substring(underscoreIdx + 1);
        const bestPriceKey = `${modalHotelId}_${modalDate}`;
        const bestPriceObj = propertyBestPrices[bestPriceKey];

        if (bestPriceObj && bestPriceObj.rate !== undefined && bestPriceObj.rate !== null && bestPriceObj.rate !== 0) {
            const enwItem = {
                provider: 'Extranetwork',
                amount: bestPriceObj.rate,
                currencyCode: bestPriceObj.currency || currency || getCurrency(),
                logo: '',
                isEnw: true,
            };
            sortedList.push(enwItem);
        }

        sortedList.sort((a, b) => {
            const amountA = (a.amount !== null && a.amount !== undefined) ? a.amount : Number.MAX_SAFE_INTEGER;
            const amountB = (b.amount !== null && b.amount !== undefined) ? b.amount : Number.MAX_SAFE_INTEGER;
            return amountA - amountB;
        });

        if (selectedSubProvider) {
            setSubProviders(selectedSubProvider);
        } else {
            setSubProviders('');
        }
        setModalProvider(sortedList.length > 0 ? sortedList[0].provider : provider);
        setModalAmount(sortedList.length > 0 ? sortedList[0].amount : amount);
        setModalCurrency(sortedList.length > 0 ? (sortedList[0].currencyCode || priceCurrency) : priceCurrency);
        setModalList(sortedList);
        
        setTimeout(() => {
            setModalOpen(true);
        }, 0);
    };

    useEffect(() => {
        const providers = Array.from(new Set(
            Object.values(prices)
                .flatMap(p => (p.all || []).map(x => x.provider && x.provider.trim().toLowerCase()))
                .filter(Boolean)
        ));
        setAllProviders(providers);

        if (props.onProvidersChange) {
            props.onProvidersChange(providers);
        }
    }, [prices]);

    const filteredModalList = selectedProvider
        ? modalList.filter(item => item.provider)
        : modalList;

    function formatAmountWithDot(amount) {
        if (typeof amount === "number" || (typeof amount === "string" && !isNaN(amount))) {
            const parts = amount.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.join(".");
        }
        return amount;
    }

    // Grafik Görünümü (Area Chart)
    const getChartData = () => {
        const labels = lsAllDays.map(date => moment(date).format('DD MMM'));

        const colorList = [
            'rgba(25, 118, 210, 0.7)',
            'rgba(220, 38, 38, 0.7)',
            'rgba(34, 197, 94, 0.7)',
            'rgba(234, 179, 8, 0.7)',
            'rgba(168, 85, 247, 0.7)',
            'rgba(59, 130, 246, 0.7)',
            'rgba(217, 255, 0, 0.7)',
            'rgba(16, 185, 129, 0.7)',
            'rgba(239, 68, 68, 0.7)',
            'rgba(99, 102, 241, 0.7)',
        ];

        const myHotelBorderColor = colorList[6];

        const myHotelDataset = currentPropertyInfo ? {
            label: currentPropertyInfo.name,
            data: lsAllDays.map(date => {
                const key = `${currentPropertyInfo.key}_${date}`;
                const priceObj = currentPropertyPrices[key];
                return (priceObj && typeof priceObj.amount === 'number') ? priceObj.amount : null;
            }),
            borderColor: myHotelBorderColor,
            tension: 0.4,
            pointHoverBackgroundColor: myHotelBorderColor,
            pointHoverBorderColor: myHotelBorderColor,
            pointRadius: 10,
            pointHoverRadius: 10,
        } : null;

        const datasets = [
            ...(myHotelDataset ? [myHotelDataset] : []),
            ...(getCpa || []).map((hotel, hotelIdx) => {
                const data = lsAllDays.map(date => {
                    const key = `${hotel.key}_${date}`;
                    const priceObj = prices[key];

                    if (selectedProvider) {
                        if (priceObj?.provider && priceObj.provider.trim().toLowerCase() === selectedProvider) {
                            return typeof priceObj.amount === 'number' ? priceObj.amount : null;
                        }
                        if (Array.isArray(priceObj?.all)) {
                            const found = priceObj.all.find(
                                item => item.provider && item.provider.trim().toLowerCase() === selectedProvider
                            );
                            return typeof found?.amount === 'number' ? found.amount : null;
                        }
                        return null;
                    }

                    if (Array.isArray(priceObj?.all)) {
                        const firstProvider = priceObj.all[0];
                        return typeof firstProvider?.amount === 'number' ? firstProvider.amount : null;
                    } else if (typeof priceObj?.amount === 'number') {
                        return priceObj.amount;
                    }
                    return null;
                });
                const borderColor = colorList[hotelIdx % colorList.length];
                return {
                    label: hotel.name,
                    data,
                    borderColor,
                    tension: 0.4,
                    pointHoverBackgroundColor: borderColor,
                    pointHoverBorderColor: borderColor,
                    pointRadius: 10,
                    pointHoverRadius: 10,
                };
            })
        ];

        return { labels, datasets };
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'top', fullSize: true },
            title: { display: false },
            tooltip: {
                position: 'nearest',
                callbacks: {
                    beforeLabel: function(context) {
                        return context.dataset.label || '';
                    },
                    label: function(context) {
                        const dateIdx = context.dataIndex;
                        const date = lsAllDays[dateIdx];
                        let amount = context.parsed.y;
                        let providerName = '';
                        let currencyLabel = currency ?? getCurrency();

                        if (context.dataset.label === currentPropertyInfo?.name) {
                            const key = `${currentPropertyInfo.key}_${date}`;
                            const priceObj = currentPropertyPrices[key];
                            amount = priceObj?.amount ?? '-';
                            providerName = " ";
                            currencyLabel = priceObj?.currency ?? currencyLabel;
                        } else {
                            const hotelIdx = context.datasetIndex - (currentPropertyInfo ? 1 : 0);
                            const hotel = (getCpa || [])[hotelIdx];
                            if (hotel && prices) {
                                const key = `${hotel.key}_${date}`;
                                const priceObj = prices[key];
                                if (selectedProvider) {
                                    if (priceObj?.provider && priceObj.provider.trim().toLowerCase() === selectedProvider) {
                                        providerName = priceObj.provider;
                                        amount = priceObj.amount;
                                    }
                                    else if (Array.isArray(priceObj?.all)) {
                                        const found = priceObj.all.find(
                                            item => item.provider && item.provider.trim().toLowerCase() === selectedProvider
                                        );
                                        if (found) {
                                            providerName = found.provider;
                                            amount = found.amount;
                                        } else {
                                            return null;
                                        }
                                    } else {
                                        return null;
                                    }
                                } else {
                                    if (Array.isArray(priceObj?.all) && priceObj.all[0]?.provider) {
                                        providerName = priceObj.all[0].provider;
                                    } else if (priceObj?.provider) {
                                        providerName = priceObj.provider;
                                    }
                                }
                                currencyLabel = priceObj?.currency ?? currencyLabel;
                            }
                        }
                        if (!providerName) return null;
                        const displayAmount = (amount === undefined || amount === null) ? '-' : amount;
                        return `${providerName}: ${displayAmount} ${currencyLabel}`;
                    }
                }
            }
        },
        interaction: {
            mode: 'nearest',
            intersect: false
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: { callback: value => value }
            }
        }
    };
    
    const hotelAmounts = [
        ...(currentPropertyInfo ? [{
            name: currentPropertyInfo.name,
            total: (() => {
                let total = 0;
                let count = 0;
                lsAllDays.forEach(date => {
                    const key = `${currentPropertyInfo.key}_${date}`;
                    const priceObj = currentPropertyPrices[key];
                    if (!priceObj || priceObj.amount === null || priceObj.amount === undefined) return;
                    total += priceObj.amount;
                    count += 1;
                });
                return count > 0 ? +(total / count).toFixed(0) : 0;
            })()
        }] : []),

        ...(getCpa || []).map((hotel) => {
            let total = 0;
            let count = 0;
            lsAllDays.forEach(date => {
                const key = `${hotel.key}_${date}`;
                const priceObj = prices[key];
                if (!priceObj || priceObj.amount === null || priceObj.amount === undefined) return;
                total += priceObj.amount;
                count += 1;
            });
            const average = count > 0 ? +(total / count).toFixed(0) : 0;
            return {
                name: hotel?.name,
                total: average
            };
        })
    ].sort((a, b) => {
        if (!a.total && b.total) return 1;
        if (a.total && !b.total) return -1;
        if (!a.total && !b.total) return 0;
        return a.total - b.total;
    });

    const promotionKeysMap = useMemo(() => {
        const map = {};
        if (!propertyList || !lsAllDays || Object.keys(promotionData).length === 0) return map;

        propertyList.forEach(hotel => {
            const promoKeysSet = new Set();
            let hasPopup = false;

            lsAllDays.forEach(date => {
                const key = `${hotel.id}_${date}`;
                const promo = promotionData[key] || null;

                if (promo?.popup && promo.popup.value !== null && promo.popup.value !== undefined) {
                    hasPopup = true;
                }

                // Tüm promotion anahtarlarını ekle (null olanlar dahil)
                if (promo?.promotion && typeof promo.promotion === 'object') {
                    Object.keys(promo.promotion).forEach(k => {
                        promoKeysSet.add(k);
                    });
                }
            });

            map[hotel.id] = { promoKeys: Array.from(promoKeysSet), hasPopup };
        });

        return map;
    }, [promotionData, propertyList, lsAllDays]);

    const getPromotionKeysForHotel = (hotelId) => {
        return promotionKeysMap[hotelId] || { promoKeys: [], hasPopup: false };
    };

    // Belirli bir otel için tüm tarihlerdeki OTA min fiyatlarını hesapla
    const getOtaStatsForHotel = (hotelId) => {
        const allAmountsTotal = [];
        const allMins = [];
        const allMaxs = [];
        const enwPrices = [];
        const mins = [];

        lsAllDays.forEach(date => {
            const stats = getOtaStatsForDate(hotelId, date);
            if (stats.avg !== null) allAmountsTotal.push(stats.avg);
            if (stats.min !== null) {
                allMins.push(stats.min);
                mins.push(stats.min);
            }
            if (stats.max !== null) allMaxs.push(stats.max);

            const bestPriceObj = propertyBestPrices[`${hotelId}_${date}`];
            if (bestPriceObj && typeof bestPriceObj.rate === 'number' && bestPriceObj.rate > 0) {
                enwPrices.push(bestPriceObj.rate);
            }
        });

        const avg = allAmountsTotal.length > 0 ? Math.round(allAmountsTotal.reduce((a, b) => a + b, 0) / allAmountsTotal.length) : null;
        const min = allMins.length > 0 ? Math.min(...allMins) : null;
        const max = allMaxs.length > 0 ? Math.max(...allMaxs) : null;

        const enwAvg = enwPrices.length > 0 ? enwPrices.reduce((a, b) => a + b, 0) / enwPrices.length : null;
        const minAvg = mins.length > 0 ? mins.reduce((a, b) => a + b, 0) / mins.length : null;
        const enwOtaRatio = (enwAvg !== null && minAvg !== null && enwAvg > 0)
            ? ((minAvg / enwAvg) * 100).toFixed(1)
            : null;

        return { avg, min, max, enwOtaRatio };
    };

    // Belirli bir tarih için OTA istatistikleri
    const getOtaStatsForDate = (hotelId, date) => {
        const key = `${hotelId}_${date}`;
        const priceObj = prices[key];
        const bestPriceObj = propertyBestPrices[key];

        // ENW fiyatı (BEST_AVAILABLE_PRICE)
        const enwPrice = (bestPriceObj && typeof bestPriceObj.rate === 'number' && bestPriceObj.rate > 0)
            ? bestPriceObj.rate
            : null;

        // OTA provider fiyatları (getCpaDailyPrice) - ENW hariç
        let otaAmounts = [];
        if (priceObj && Array.isArray(priceObj.all)) {
            priceObj.all.forEach(p => {
                if (typeof p.amount === 'number' && p.amount > 0) {
                    otaAmounts.push(p.amount);
                }
            });
        } else if (priceObj && typeof priceObj.amount === 'number' && priceObj.amount > 0) {
            otaAmounts.push(priceObj.amount);
        }

        // Ortalama, Min, Max: ENW + OTA hepsi dahil
        let allAmounts = [...otaAmounts];
        if (enwPrice !== null) {
            allAmounts.push(enwPrice);
        }

        const avg = allAmounts.length > 0 ? Math.round(allAmounts.reduce((a, b) => a + b, 0) / allAmounts.length) : null;
        const min = allAmounts.length > 0 ? Math.min(...allAmounts) : null;
        const max = allAmounts.length > 0 ? Math.max(...allAmounts) : null;
        const price = enwPrice;

        // ENW/OTA = (ENW - OTA Min) / ENW * 100
        const otaMin = otaAmounts.length > 0 ? Math.min(...otaAmounts) : null;
        const enwOtaRatio = (enwPrice !== null && otaMin !== null && enwPrice > 0)
            ? (((enwPrice - otaMin) / enwPrice) * 100).toFixed(1)
            : null;

        return { avg, min, max, enwOtaRatio, price };
    };
    

    const getPromotionForDate = (hotelId, date) => {
        const key = `${hotelId}_${date}`;
        return promotionData[key] || null;
    };

    // Promotion label
    const getPromotionLabel = (code) => {
        const labels = {
            'PRD': t('promotion_type-early_booking-period') ,
            'BFD': t('promotion_type-early_booking-before_day'),
            'LST': t('promotion_type-last-minute'),
            'DSC': t('promotion_type-discount'),
        };
        return labels[code] || code;
    };

    return (
        <>
            {
                fetching ?
                    <InventorySkeleton />
                    :
                    <>
                        {
                            propertyList ?
                                <>
                                
                                {window.innerWidth < 768 && (
                                <>
                                    {propertyList.map((hotel) =>
                                        <div key={hotel.id} className="mobile-competitor-hotel-card">
                                            <div className="mobile-competitor-hotel-header">
                                                <i className="gray fas fa-hotel" />
                                                <span className="mobile-competitor-hotel-name">{hotel?.name}</span>
                                            </div>
                                            <div className="mobile-competitor-prices-list">
                                                {lsAllDays.map((date) => {
                                                    const key = `${hotel.id}_${date}`;
                                                    const priceObj = prices[key];
                                                    const isWeekend = [5, 6].includes(moment(date).locale('de').weekday());
                                                    
                                                    const bestPriceObj = propertyBestPrices[key];
                                                    const filteredPrice = getPriceForProviderFilter(hotel.id, date);
                                                    let displayAmount = "-";
                                                    let displayProvider = "-";

                                                    if (selectedProvider) {
                                                        if (filteredPrice.amount !== null && filteredPrice.amount !== undefined) {
                                                            displayAmount = filteredPrice.amount;
                                                            displayProvider = filteredPrice.provider || selectedProvider;
                                                        }
                                                    } else {
                                                        if (bestPriceObj && bestPriceObj.rate !== undefined && bestPriceObj.rate !== null && bestPriceObj.rate !== 0) {
                                                            displayAmount = bestPriceObj.rate;
                                                            displayProvider = 'Extranetwork';
                                                        }
                                                    }

                                                    return (
                                                        <div
                                                            className={`mobile-competitor-price-card${isWeekend ? " weekend-inputs" : ""}`}
                                                            key={key}
                                                            style={{ cursor: priceObj ? 'pointer' : 'default', position: 'relative' }}
                                                            onClick={priceObj && !loading[key] && !error[key] ? (e) => openModal(e, key) : undefined}
                                                        >
                                                            <div className="mobile-competitor-date">
                                                                {moment(date).format('DD MMM ddd')}
                                                            </div>
                                                            <div className="mobile-competitor-amount">
                                                                {loading[key] ? (
                                                                    <CircularProgress
                                                                        className='circularProgress-report-mobile'
                                                                        style={{
                                                                            color: "#d71f26",
                                                                            zIndex: "99"
                                                                        }}
                                                                        size={16}
                                                                    />
                                                                ) : error[key] ? (
                                                                    <span style={{height: "auto", width: "auto"}}>-</span>
                                                                ) : (
                                                                    <>
                                                                        <span style={{height: "auto", width: "auto"}}>{typeof displayAmount === 'number' ? displayAmount : displayAmount} {currency ?? getCurrency()}</span>
                                                                    </>
                                                                )}
                                                                <span className="mobile-competitor-provider">{displayProvider}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                                    <ColAtm className="inventory-box">
                                        <ColAtm className="inventory-room-box">
                                            <ColAtm xs={3} lg={4} className="align-self-center">
                                                {/* <BlockAtm md={1} className="m-h-auto">
                                                </BlockAtm> */}
                                                {/* <BlockAtm xs={4}>
                                                    <LabelAtm labelClass="inventory-room-name"
                                                        text={t('enw-cpa_price-title')} style={{marginTop: 10}} />
                                                </BlockAtm> */}
                                                <BlockAtm xs={12}>
                                                    {/* Grup Filtre SelectBox */}
                                                    <FormControl
                                                        variant="outlined"
                                                        size="small"
                                                        className="group-select-box"
                                                        style={{
                                                            minWidth: 180,
                                                            backgroundColor: '#fff',
                                                            borderRadius: 8,
                                                            marginLeft: 16,
                                                        }}
                                                    >
                                                        <InputLabel style={{ fontWeight: 500 }}>
                                                            {'Grup Filtrele'}
                                                        </InputLabel>
                                                        <Select
                                                            value={selectedGroupId}
                                                            onChange={onGroupFilterChange}
                                                            label={'Grup Filtrele'}
                                                            style={{ borderRadius: 8 }}
                                                            disabled={cpaGroupFetching}
                                                            displayEmpty
                                                            renderValue={(selected) => {
                                                                if (!selected) {
                                                                    return (
                                                                        <span style={{ fontStyle: 'italic' }}>
                                                                            Tüm Oteller (Grupsuz)
                                                                        </span>
                                                                    );
                                                                }

                                                                const group = cpaGroup?.find(g => g.id === selected);
                                                                return (
                                                                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                                                        {/* <i
                                                                            className="fas fa-folder"
                                                                            style={{ fontSize: 12, color: '#f57c00' }}
                                                                        /> */}
                                                                        {group?.name}
                                                                    </Box>
                                                                );
                                                            }}
                                                            startAdornment={
                                                                <i
                                                                    className="fas fa-layer-group"
                                                                    style={{
                                                                        color: '#667eea',
                                                                        marginRight: 8,
                                                                        marginLeft: 4,
                                                                        fontSize: 13
                                                                    }}
                                                                />
                                                            }
                                                        >
                                                            <MenuItem value="">
                                                                <em>Tüm Oteller (Grupsuz)</em>
                                                            </MenuItem>

                                                            {cpaGroup?.map((group) => (
                                                                <MenuItem key={group?.id} value={group?.id}>
                                                                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                                                        {/* <i
                                                                            className="fas fa-folder"
                                                                            style={{ fontSize: 12, color: '#f57c00' }}
                                                                        /> */}
                                                                        {group?.name}
                                                                    </Box>
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </BlockAtm>
                                                <Grid item xs={4} />
                                            </ColAtm>
                                            <ColAtm xs={7} className="inventory-date-padding pos-relative" />
                                            <ColAtm xs={1} className="competitor-excel">
                                            </ColAtm>
                                        </ColAtm>
                                        {propertyList?.length < 1 &&
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    minHeight: 120,
                                                    color: "#888",
                                                    fontSize: 18,
                                                    fontWeight: 500,
                                                    marginTop: "12px",
                                                    width: "100%"
                                                }}
                                            >
                                                <i className="fas fa-hotel" style={{ fontSize: 36, color: "#667eea94", marginBottom: 12 }} />
                                                Bu Grupta Otel Bulunamadı.
                                            </div>
                                        }
                                        {
                                            cpaGroupMappingFetching &&
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    minHeight: 120,
                                                    width: "100%",
                                                    position: "absolute",
                                                    top: "40%"
                                                }}>
                                                    <CircularProgress
                                                        style={{ color: "#d71f26" }}
                                                        size={32}
                                                    />
                                                </div>
                                        }
                                        {propertyList.map((hotel) => {
                                            // Fiyat key'i belirle: tripadvisor vs için _cpaKey, extranetwork için hotel.id
                                            const hotelPriceKey = (hotel._source && hotel._source !== "extranetwork") 
                                                ? hotel._cpaKey 
                                                : hotel.id;
                                            
                                            return (
                                            <ColAtm className="inventory-avail-box m-h-33" style={openedHotelKey !== hotel.id ? { height: "43px" } : {}} key={hotel._cpaKey || hotel.id}>
                                                <ColAtm xs={2}>
                                                    <Grid item md={1}></Grid>
                                                    <Grid item md={1}>
                                                        <Button
                                                            size="small"
                                                            style={{
                                                                minWidth: 24,
                                                                height: 24,
                                                                padding: 0,
                                                                marginLeft: '-8px',
                                                                marginTop: '-1px',
                                                                borderRadius: "50%",
                                                                background: "#e3f2fd",
                                                                color: "#1976d2",
                                                                fontWeight: "bold",
                                                                fontSize: 18,
                                                                lineHeight: 1,
                                                            }}
                                                            onClick={() => setOpenedHotelKey(openedHotelKey === hotel.id ? null : hotel.id)}
                                                            disabled={Object.keys(prices).length > 0 ? false : true}
                                                            aria-label="Add"
                                                            >
                                                            {openedHotelKey === hotel.id ? '-' : '+'}
                                                        </Button>
                                                    </Grid>
                                                    <Grid item md={10}>
                                                        <LabelAtm labelClass="inventory-room-name" style={{display: 'inline-block', width: "300px"}} text={hotel?.name} />
                                                           
                                                            {openedHotelKey === hotel.id && (
                                                                <>
                                                                {(() => {
                                                                    let providerSet = new Map();
                                                                    
                                                                    lsAllDays.forEach(date => {
                                                                        const key = `${hotel.id}_${date}`;
                                                                        const priceObj = prices[key];
                                                                        if (Array.isArray(priceObj?.all)) {
                                                                            priceObj.all.forEach(p => {
                                                                                if (p.provider && p.amount !== undefined && p.amount !== null) {
                                                                                    if (!providerSet.has(p.provider)) {
                                                                                        providerSet.set(p.provider, { 
                                                                                            provider: p.provider, 
                                                                                            logo: p.logo || '',
                                                                                            hasData: true
                                                                                        });
                                                                                    }
                                                                                }
                                                                            });
                                                                        }
                                                                    });

                                                                    let providerObjs = Array.from(providerSet.values());

                                                                    // if (selectedProvider) {
                                                                    //     providerObjs = providerObjs.filter(
                                                                    //         p => p.provider.trim().toLowerCase() === selectedProvider.trim().toLowerCase()
                                                                    //     );
                                                                    // }

                                                                    const firstDate = lsAllDays[0];
                                                                    const firstKey = `${hotel.id}_${firstDate}`;
                                                                    const firstPriceObj = prices[firstKey];
                                                                    
                                                                    providerObjs.sort((a, b) => {
                                                                        let amountA = Number.MAX_SAFE_INTEGER;
                                                                        let amountB = Number.MAX_SAFE_INTEGER;
                                                                        
                                                                        if (Array.isArray(firstPriceObj?.all)) {
                                                                            const foundA = firstPriceObj.all.find(p => p.provider === a.provider);
                                                                            const foundB = firstPriceObj.all.find(p => p.provider === b.provider);
                                                                            if (foundA && typeof foundA.amount === "number") amountA = foundA.amount;
                                                                            if (foundB && typeof foundB.amount === "number") amountB = foundB.amount;
                                                                        }
                                                                        
                                                                        return amountA - amountB;
                                                                    });

                                                                    return providerObjs;
                                                                })().map((provider, idx) => (
                                                                    <div
                                                                        key={idx}
                                                                        style={{
                                                                            marginTop: '26px',
                                                                            marginBottom: '26px',
                                                                        }}
                                                                    >
                                                                        <div className="cpa-border" style={{
                                                                            position: "absolute",
                                                                            width: 1590,
                                                                            borderRadius: "8px",
                                                                            height: 55,
                                                                            background: idx % 2 === 0 ? '#f5faff' : undefined,
                                                                        }}></div>
                                                                        <LabelAtm
                                                                            labelClass="inventory-room-name"
                                                                            style={{padding: "2px 0", fontSize: 14, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2}}
                                                                            text={
                                                                                <>
                                                                                    <img 
                                                                                        src={provider?.logo ?? ''}
                                                                                        alt="Provider Logo"
                                                                                        style={{width: "100px", height: "50px", maxWidth: '100px', maxHeight: '50px', marginLeft: 20, verticalAlign: 'middle'}}
                                                                                    />
                                                                                </>
                                                                            }
                                                                        />
                                                                        
                                                                    </div>
                                                                ))}

                                                                {/* ENW satırı */}
                                                                <div style={{ marginTop: '44px', marginBottom: '36px' }}>
                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700, color: '#000000' }}
                                                                        text={<>{'Extranetwork'}</>} />
                                                                    <div className="cpa-border" style={{ position: "absolute", width: 1590, borderRadius: "8px", height: 55}}>
                                                                        { window.innerWidth > 768 && <Divider className="current-property-divider" style={{width: "100%", display: "flex", margin: "0 auto", marginTop: 10}} /> }
                                                                    </div>
                                                                </div>

                                                                {/* Min satırı */}
                                                                <div style={{ marginTop: '26px', marginBottom: '26px' }}>
                                                                    <div className="cpa-border" style={{ position: "absolute", width: 1590, borderRadius: "8px", height: 55}}></div>
                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700, color: '#388e3c' }}
                                                                        text={<>{t('enw-cpa-min')}</>} />
                                                                </div>

                                                                {/* Ortalama satırı */}
                                                                <div style={{ marginTop: '26px', marginBottom: '26px' }}>
                                                                    <div className="cpa-border" style={{ position: "absolute", width: 1590, borderRadius: "8px", height: 55 }}></div>
                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700, color: '#f57c00' }}
                                                                        text={<>{t('enw-cpa-average_prices-title')}</>} />
                                                                </div>
                                                                
                                                                {/* Max satırı */}
                                                                <div style={{ marginTop: '26px', marginBottom: '36px' }}>
                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700, color: '#d32f2f' }}
                                                                        text={<>{t('enw-cpa-max')}</>} />
                                                                    <div className="cpa-border" style={{ position: "absolute", width: 1590, borderRadius: "8px", height: 55}}>
                                                                        { window.innerWidth > 768 && <Divider className="current-property-divider" style={{width: "100%", display: "flex", margin: "0 auto", marginTop: 25}} /> }
                                                                    </div>
                                                                </div>

                                                                {/* Last Price satırı */}
                                                                <div style={{ marginTop: '46px', marginBottom: '26px' }}>
                                                                    <div className="cpa-border" style={{ position: "absolute", width: 1590, borderRadius: "8px", height: 55 }}></div>
                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700, color: '#23c015' }}
                                                                        text={<>Son Fiyat</>} />
                                                                </div>
                                                                
                                                                {/* Ortalama Fiyata Göre Fayda satırı */}
                                                                <div style={{ marginTop: '46px', marginBottom: '26px' }}>
                                                                    <div className="cpa-border" style={{ position: "absolute", width: 1590, borderRadius: "8px", height: 55 }}></div>
                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700 }}
                                                                        text={<>Ortalama Fiyata Göre Fayda</>} />
                                                                </div>
                                                                
                                                                {/* Minimum Fiyata Göre Fayda satırı */}
                                                                <div style={{ marginTop: '46px', marginBottom: '26px' }}>
                                                                    <div className="cpa-border" style={{ position: "absolute", width: 1590, borderRadius: "8px", height: 55 }}></div>
                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700 }}
                                                                        text={<>Minimum Fiyata Göre Fayda</>} />
                                                                </div>
                                                                
                                                                {/* ENW/OTA satırı */}
                                                                <div style={{ marginTop: '36px', marginBottom: '26px' }}>
                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700, color: '#1565c0' }}
                                                                        text={<>ENW/OTA</>} />
                                                                    <div className="cpa-border" style={{ position: "absolute", width: 1590, borderRadius: "8px", height: 55}}>
                                                                        { window.innerWidth > 768 && <Divider className="current-property-divider" style={{width: "100%", display: "flex", margin: "0 auto", marginTop: 25}} /> }
                                                                    </div>
                                                                </div>
                                                                {/* Promotion satırları */}
                                                                {(() => {
                                                                    const { promoKeys, hasPopup } = getPromotionKeysForHotel(hotel.id);

                                                                    return (
                                                                        <>  
                                                                            {promoKeys.map((promoKey, pIdx) => (
                                                                                <div key={`promo-label-${promoKey}`} style={{ marginTop: '46px', marginBottom: '26px' }}>
                                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700, color: '#555', width: "400px" }}
                                                                                        text={<>{getPromotionLabel(promoKey)}</>} />
                                                                                        {
                                                                                            promoKeys?.length - 1 === pIdx && hasPopup &&
                                                                                            <div className="cpa-border" style={{ position: "absolute", width: 1590, borderRadius: "8px", height: 55}}>
                                                                                                { window.innerWidth > 768 && <Divider className="current-property-divider" style={{width: "100%", display: "flex", margin: "0 auto", marginTop: 25}} /> }
                                                                                            </div>
                                                                                        }
                                                                                </div>
                                                                            ))}
                                                                            {hasPopup && (
                                                                                <div style={{ marginTop: '46px', marginBottom: '26px' }}>
                                                                                    <LabelAtm labelClass="inventory-room-name" style={{ padding: "2px 0", fontSize: 13, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2, fontWeight: 700, color: '#7b1fa2' }}
                                                                                        text={<>Pop-up</>} />
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    );
                                                                })()}
                                                                </>
                                                            )}
                                                    </Grid>
                                                    <BlockAtm className="channels-box" md={2}></BlockAtm>
                                                    <BlockAtm className="inventory-copy-box" md={3}></BlockAtm>
                                                </ColAtm>
                                                <ColAtm xs={10}>
                                                    <Grid container className="inventory-rate-price">
                                                        <ColAtm xs={2} />
                                                        <Grid xs={10} className="m-overflow-inventory-price">
                                                            <ColAtm className="inventory-price-padding" style={{marginBottom: "32px"}}>
                                                                {
                                                                lsAllDays.map((date) => {
                                                                    const key = `${hotelPriceKey}_${date}`;
                                                                    const priceObj = prices[key];
                                                                    
                                                                    const bestPriceObj = propertyBestPrices[key];
                                                                    const filteredPrice = getPriceForProviderFilter(hotelPriceKey, date);
                                                                    let displayAmount = "-";
                                                                    let displayCurrency = currency ?? getCurrency();
                                                                    let tooltipText = '';

                                                                    if (selectedProvider) {
                                                                        if (filteredPrice.amount !== null && filteredPrice.amount !== undefined) {
                                                                            displayAmount = filteredPrice.amount;
                                                                            displayCurrency = filteredPrice.currency || displayCurrency;
                                                                            tooltipText = filteredPrice.provider || selectedProvider;
                                                                        }
                                                                    } else {
                                                                        if (bestPriceObj && bestPriceObj.rate !== undefined && bestPriceObj.rate !== null && bestPriceObj.rate !== 0) {
                                                                            displayAmount = bestPriceObj.rate;
                                                                            displayCurrency = bestPriceObj.currency || displayCurrency;
                                                                            tooltipText = 'Extranetwork';
                                                                        }
                                                                    }

                                                                    return (
                                                                        <BlockAtm
                                                                            key={key}
                                                                            style={{marginTop:"0px", marginBottom: '32px'}}
                                                                            className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`}
                                                                        >
                                                                            {loading[key] ? (
                                                                                <CircularProgress
                                                                                    className='circularProgress-report'
                                                                                    style={{
                                                                                        color: "#d71f26",
                                                                                        zIndex: "99"
                                                                                    }}
                                                                                    size={16}
                                                                                />
                                                                            ) : (
                                                                                <Tooltip
                                                                                    PopperProps={{ disablePortal: true }}
                                                                                    title={tooltipText}
                                                                                >
                                                                                    <div
                                                                                        id={key}
                                                                                        onClick={priceObj ? (e => openModal(e, key)) : undefined}
                                                                                        className="MuiFormControl-root MuiTextField-root type-number-hidden MuiFormControl-fullWidth"
                                                                                        style={{ cursor: priceObj ? 'pointer' : 'default' }}
                                                                                    >
                                                                                        <span style={{height: "auto", width: "auto"}}>{typeof displayAmount === 'number' ? formatAmountWithDot(displayAmount) : displayAmount}</span>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            )}

                                                                            <p className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-radius-cpa'} null-inventory`}> &nbsp;</p>
                                                                        </BlockAtm>
                                                                    );
                                                                })
                                                            }
                                                                <p className="inventory-currency">{currency ?? getCurrency()}</p>
                                                            </ColAtm>
                                                        {openedHotelKey === hotel.id && (
                                                            <div style={{marginTop: "-19px"}}>
                                                                <style>{`
                                                                    .weekend-radius-cpa {
                                                                        height:0px;
                                                                    }
                                                                `}</style>
                                                                {(() => {
                                                                    let providerSet = new Map();
                                                                    
                                                                    lsAllDays.forEach(date => {
                                                                        const key = `${hotel.id}_${date}`;
                                                                        const priceObj = prices[key];
                                                                        if (Array.isArray(priceObj?.all)) {
                                                                            priceObj.all.forEach(p => {
                                                                                if (p.provider && p.amount !== undefined && p.amount !== null) {
                                                                                    if (!providerSet.has(p.provider)) {
                                                                                        providerSet.set(p.provider, { 
                                                                                            provider: p.provider, 
                                                                                            logo: p.logo || '',
                                                                                            hasData: true
                                                                                        });
                                                                                    }
                                                                                }
                                                                            });
                                                                        }
                                                                    });

                                                                    let providerObjs = Array.from(providerSet.values());

                                                                    // Provider filtresi uygula
                                                                    // if (selectedProvider) {
                                                                    //     providerObjs = providerObjs.filter(
                                                                    //         p => p.provider.trim().toLowerCase() === selectedProvider.trim().toLowerCase()
                                                                    //     );
                                                                    // }

                                                                    const firstDate = lsAllDays[0];
                                                                    const firstKey = `${hotel.id}_${firstDate}`;
                                                                    const firstPriceObj = prices[firstKey];
                                                                    
                                                                    providerObjs.sort((a, b) => {
                                                                        let amountA = Number.MAX_SAFE_INTEGER;
                                                                        let amountB = Number.MAX_SAFE_INTEGER;
                                                                        
                                                                        if (Array.isArray(firstPriceObj?.all)) {
                                                                            const foundA = firstPriceObj.all.find(p => p.provider === a.provider);
                                                                            const foundB = firstPriceObj.all.find(p => p.provider === b.provider);
                                                                            if (foundA && typeof foundA.amount === "number") amountA = foundA.amount;
                                                                            if (foundB && typeof foundB.amount === "number") amountB = foundB.amount;
                                                                        }
                                                                        
                                                                        return amountA - amountB;
                                                                    });

                                                                    // Provider satırları
                                                                    const providerRows = providerObjs.map((providerObj, pIdx) => (
                                                                        <div
                                                                            key={`provider-row-${providerObj.provider}-${pIdx}`}
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                marginBottom: "57px",
                                                                            }}
                                                                            className="inventory-price-padding"
                                                                        >
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const key = `${hotel.id}_${date}`;
                                                                                const priceObj = prices[key];
                                                                                let amount = "-";
                                                                                let hasProviderData = false;

                                                                                if (Array.isArray(priceObj?.all)) {
                                                                                    const found = priceObj.all.find(p => p.provider === providerObj.provider);
                                                                                    if (found && found.amount !== undefined && found.amount !== null) {
                                                                                        amount = found.amount;
                                                                                        hasProviderData = true;
                                                                                    }
                                                                                }

                                                                                return (
                                                                                    <BlockAtm
                                                                                        key={`${providerObj.provider}-${date}-${dIdx}`}
                                                                                        className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`}
                                                                                        style={{minWidth: 60}}
                                                                                    >
                                                                                        {loading[key] ? (
                                                                                            <CircularProgress
                                                                                                className='circularProgress-report'
                                                                                                style={{
                                                                                                    color: "#d71f26",
                                                                                                    zIndex: "99"
                                                                                                }}
                                                                                                size={16}
                                                                                            />
                                                                                        ) : error[key] ? (
                                                                                            <span style={{height: "auto", width: "auto"}}>-</span>
                                                                                        ) : hasProviderData ? (
                                                                                            <Tooltip
                                                                                                PopperProps={{ disablePortal: true }}
                                                                                                title={providerObj.provider}
                                                                                            >
                                                                                                <div
                                                                                                    id={`${providerObj.provider}-${date}`}
                                                                                                    onClick={e => openModal(e, key, providerObj.provider)}
                                                                                                    className="MuiFormControl-root MuiTextField-root type-number-hidden MuiFormControl-fullWidth"
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                >
                                                                                                    <span style={{height: "auto", width: "auto", display: 'inline-block'}}>{formatAmountWithDot(amount)}</span>
                                                                                                </div>
                                                                                            </Tooltip>
                                                                                        ) : <div>-</div>
                                                                                        }
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}>{currency ?? getCurrency()}</p>
                                                                        </div>
                                                                    ));

                                                                    //Last Price statırı
                                                                    const LastPriceRow = (
                                                                        <div key="stat-lastprice" style={{ display: "flex", alignItems: "center", marginBottom: "36px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const stats = getOtaStatsForDate(hotel.id, date);
                                                                                const key = `${hotel.id}_${date}`;
                                                                                const promo = promotionData[key] || null;
                                                                                const popup = promo?.popup;
                                                                                let popupValue = 0;
                                                                                let popupType = null;

                                                                                if (popup && popup?.value !== null && popup?.value !== undefined) {
                                                                                    popupValue = popup?.value;
                                                                                    popupType = popup?.type;
                                                                                }

                                                                                let lastPrice = stats?.price;
                                                                                if (lastPrice !== null && lastPrice !== undefined && popupValue && popupType === 'PER') {
                                                                                    lastPrice = lastPrice - (lastPrice * popupValue / 100);
                                                                                } else if (lastPrice !== null && lastPrice !== undefined && popupValue && popupType === 'AMT') {
                                                                                    lastPrice = lastPrice - popupValue;
                                                                                }

                                                                                return (
                                                                                    <BlockAtm key={`lastprice-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block', color: '#23c015'}}>
                                                                                            {lastPrice !== null && !isNaN(lastPrice) ? formatAmountWithDot(Math.round(lastPrice)) : '-'}
                                                                                        </span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}>{currency ?? getCurrency()}</p>
                                                                        </div>
                                                                    );

                                                                    // Enw Price satırı
                                                                    const priceRow = (
                                                                        <div key="stat-min" style={{ display: "flex", alignItems: "center", marginBottom: "36px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const stats = getOtaStatsForDate(hotel.id, date);
                                                                                return (
                                                                                    <BlockAtm key={`min-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block'}}>{stats.price !== null ? formatAmountWithDot(stats.price) : '-'}</span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}>{currency ?? getCurrency()}</p>
                                                                        </div>
                                                                    );
                                                                    
                                                                    // Min satırı
                                                                    const minRow = (
                                                                        <div key="stat-min" style={{ display: "flex", alignItems: "center", marginBottom: "36px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const stats = getOtaStatsForDate(hotel.id, date);
                                                                                return (
                                                                                    <BlockAtm key={`min-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block', color: '#388e3c'}}>{stats.min !== null ? formatAmountWithDot(stats.min) : '-'}</span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}>{currency ?? getCurrency()}</p>
                                                                        </div>
                                                                    );

                                                                    // Ortalama satırı
                                                                    const avgRow = (
                                                                        <div key="stat-avg" style={{ display: "flex", alignItems: "center", marginBottom: "36px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const stats = getOtaStatsForDate(hotel.id, date);
                                                                                return (
                                                                                    <BlockAtm key={`avg-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block', color: '#f57c00'}}>{stats.avg !== null ? formatAmountWithDot(stats.avg) : '-'}</span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}>{currency ?? getCurrency()}</p>
                                                                        </div>
                                                                    );

                                                                    // Max satırı
                                                                    const maxRow = (
                                                                        <div key="stat-max" style={{ display: "flex", alignItems: "center", marginBottom: "36px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const stats = getOtaStatsForDate(hotel.id, date);
                                                                                return (
                                                                                    <BlockAtm key={`max-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block', color: '#d32f2f'}}>{stats.max !== null ? formatAmountWithDot(stats.max) : '-'}</span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}>{currency ?? getCurrency()}</p>
                                                                        </div>
                                                                    );

                                                                    // ENW/OTA satırı
                                                                    const enwOtaRow = (
                                                                        <div key="stat-enwota" style={{ display: "flex", alignItems: "center", marginBottom: "36px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const stats = getOtaStatsForDate(hotel.id, date);
                                                                                return (
                                                                                    <BlockAtm key={`enwota-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block', color: '#1565c0'}}>{stats.enwOtaRatio !== null ? `${stats.enwOtaRatio}%` : '-'}</span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}></p>
                                                                        </div>
                                                                    );

                                                                    // Ortalama Fiyata Göre Fayda satırı
                                                                    // Formül: (avg - lastPrice) / lastPrice * 100
                                                                    const avgBenefitRow = (
                                                                        <div key="stat-avg-benefit" style={{ display: "flex", alignItems: "center", marginBottom: "36px", marginTop: "46px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const stats = getOtaStatsForDate(hotel.id, date);
                                                                                const key = `${hotel.id}_${date}`;
                                                                                const promo = promotionData[key] || null;
                                                                                const popup = promo?.popup;
                                                                                let popupValue = 0;
                                                                                let popupType = null;

                                                                                if (popup && popup?.value !== null && popup?.value !== undefined) {
                                                                                    popupValue = popup?.value;
                                                                                    popupType = popup?.type;
                                                                                }

                                                                                let lastPrice = stats?.price;
                                                                                if (lastPrice !== null && lastPrice !== undefined && popupValue && popupType === 'PER') {
                                                                                    lastPrice = lastPrice - (lastPrice * popupValue / 100);
                                                                                } else if (lastPrice !== null && lastPrice !== undefined && popupValue && popupType === 'AMT') {
                                                                                    lastPrice = lastPrice - popupValue;
                                                                                }

                                                                                const avgBenefit = (stats?.avg !== null && lastPrice !== null && lastPrice !== undefined && lastPrice !== 0 && !isNaN(lastPrice))
                                                                                    ? ((stats?.avg - lastPrice) / lastPrice * 100).toFixed(1)
                                                                                    : null;

                                                                                return (
                                                                                    <BlockAtm key={`avg-benefit-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block', color: avgBenefit !== null && parseFloat(avgBenefit) >= 0 ? '#23c015' : '#d32f2f'}}>
                                                                                            {avgBenefit !== null ? `${avgBenefit}%` : '-'}
                                                                                        </span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}></p>
                                                                        </div>
                                                                    );

                                                                    // Minimum Fiyata Göre Fayda satırı
                                                                    // Formül: (min - lastPrice) / lastPrice * 100
                                                                    const minBenefitRow = (
                                                                        <div key="stat-min-benefit" style={{ display: "flex", alignItems: "center", marginBottom: "36px", marginTop: "46px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const stats = getOtaStatsForDate(hotel.id, date);
                                                                                const key = `${hotel.id}_${date}`;
                                                                                const promo = promotionData[key] || null;
                                                                                const popup = promo?.popup;
                                                                                let popupValue = 0;
                                                                                let popupType = null;

                                                                                if (popup && popup?.value !== null && popup?.value !== undefined) {
                                                                                    popupValue = popup?.value;
                                                                                    popupType = popup?.type;
                                                                                }

                                                                                let lastPrice = stats?.price;
                                                                                if (lastPrice !== null && lastPrice !== undefined && popupValue && popupType === 'PER') {
                                                                                    lastPrice = lastPrice - (lastPrice * popupValue / 100);
                                                                                } else if (lastPrice !== null && lastPrice !== undefined && popupValue && popupType === 'AMT') {
                                                                                    lastPrice = lastPrice - popupValue;
                                                                                }

                                                                                const minBenefit = (stats?.min !== null && lastPrice !== null && lastPrice !== undefined && lastPrice !== 0 && !isNaN(lastPrice))
                                                                                    ? ((stats?.min - lastPrice) / lastPrice * 100).toFixed(1)
                                                                                    : null;

                                                                                return (
                                                                                    <BlockAtm key={`min-benefit-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block', color: minBenefit !== null && parseFloat(minBenefit) >= 0 ? '#23c015' : '#d32f2f'}}>
                                                                                            {minBenefit !== null ? `${minBenefit}%` : '-'}
                                                                                        </span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}></p>
                                                                        </div>
                                                                    );

                                                                    // Promotion satırları
                                                                    const { promoKeys, hasPopup } = getPromotionKeysForHotel(hotel.id);

                                                                    const popupRow = hasPopup ? (
                                                                        <div key="promo-popup" style={{ display: "flex", alignItems: "center", marginBottom: "36px", marginTop: "56px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const key = `${hotel.id}_${date}`;
                                                                                const promo = promotionData[key] || null;
                                                                                const popup = promo?.popup;
                                                                                let displayVal = '-';
                                                                                if (popup && popup.value !== null && popup.value !== undefined) {
                                                                                    displayVal = popup.type === 'PER' ? `${popup.value}%` : popup.value;
                                                                                }
                                                                                return (
                                                                                    <BlockAtm key={`popup-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block', color: '#7b1fa2'}}>{displayVal}</span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}></p>
                                                                        </div>
                                                                    ) : null;

                                                                    const promoRows = promoKeys.map((promoKey) => (
                                                                        <div key={`promo-${promoKey}`} style={{ display: "flex", alignItems: "center", marginBottom: "46px", marginTop: "46px" }} className="inventory-price-padding">
                                                                            {lsAllDays.map((date, dIdx) => {
                                                                                const key = `${hotel.id}_${date}`;
                                                                                const promo = promotionData[key] || null;
                                                                                const promoItem = promo?.promotion?.[promoKey];
                                                                                let displayVal = '-';
                                                                                if (promoItem && typeof promoItem === 'object' && promoItem.value !== null && promoItem.value !== undefined) {
                                                                                    displayVal = promoItem.type === 'PER' ? `${promoItem.value}%` : promoItem.value;
                                                                                    if (promoItem.is_mobile === 1) {
                                                                                        displayVal += '';
                                                                                    }
                                                                                }
                                                                                return (
                                                                                    <BlockAtm key={`promo-${promoKey}-${date}-${dIdx}`} className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`} style={{minWidth: 60}}>
                                                                                        <span style={{height: "auto", width: "auto", display: 'inline-block', color: '#555'}}>{displayVal}</span>
                                                                                    </BlockAtm>
                                                                                );
                                                                            })}
                                                                            <p className="inventory-currency" style={{marginTop: "0px"}}></p>
                                                                        </div>
                                                                    ));

                                                                    return (
                                                                        <div>
                                                                            {providerRows}
                                                                            {priceRow}
                                                                            {minRow}
                                                                            {avgRow}
                                                                            {maxRow}
                                                                            {LastPriceRow}
                                                                            {avgBenefitRow}
                                                                            {minBenefitRow}
                                                                            {enwOtaRow}
                                                                            {promoRows}
                                                                            {popupRow}
                                                                        </div>
                                                                    );
                                                                })()}
                                                            </div>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </ColAtm>
                                            </ColAtm>
                                        )})}
                                    </ColAtm>
                                    <style>{`
                                        @media screen and (max-width: 768px) {
                                            .inventory-box { 
                                                display: none !important; 
                                            }
                                        }
                                        @media (min-width: 1023px) and (max-width: 1533px) {
                                            .cpa-border {
                                                width: 1420px !important;
                                            }
                                        }
                                        @media (min-width: 1980px) and (max-width: 2490px) {
                                            .cpa-border {
                                                width: 1610px !important;
                                            }
                                        }
                                        .MuiDialog-paperWidthXs {
                                            max-width:700px!important;
                                        }
                                        .inventory-price span {
                                            position:relative!important
                                        }
                                        .MuiSelect-select:focus {
                                            background-color:#fff!important
                                        }
                                        @media screen and (max-width: 768px) {
                                            .MuiDialog-paperFullWidth {
                                                width:100% !important;
                                            }
                                        }
                                        .inventory-rate-price {
                                            align-items:baseline!important;
                                        }
                                        .weekend-radius-cpa {
                                            margin-top:-97px;
                                        }
                                        @media screen and (min-width: 768px) {
                                            .inventory-currency {
                                                top: 0 !important; 
                                            }
                                        }
                                        .group-select-box .MuiOutlinedInput-notchedOutline {
                                            border-color: transparent !important;
                                            border-radius:8px !important;
                                        }
                                        .group-select-box .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
                                            border-color: transparent !important;
                                            border-radius:8px !important;
                                        }
                                        .group-select-box .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
                                            border-color: transparent !important;
                                            border-radius:8px !important;
                                        }
                                        .group-select-box .MuiSelect-select:focus {
                                            background-color: #fff !important;
                                            border-radius: 8px !important;
                                        }
                                        .inventory-room-box {
                                            height: 54px !important;
                                        }
                                    `}</style>
                                    <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="xs" fullWidth>
                                        <DialogTitle>
                                            {t('enw-input-provider_prices-title')}
                                            <IconButton
                                                aria-label="close"
                                                onClick={() => setModalOpen(false)}
                                                style={{ position: 'absolute', right: 8, top: 8 }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </DialogTitle>
                                        <DialogContent dividers>
                                            {filteredModalList.length > 0 ? (
                                                <table className="cpa-modal-table">
                                                    <thead>
                                                        <tr className="cpa-modal-table-header">
                                                            <td colSpan={2} className="cpa-modal-table-header-cell">
                                                                {"1. "} {modalProvider} - {modalAmount} {modalCurrency}
                                                            </td>
                                                        </tr>
                                                        <tr className="cpa-modal-table-titles">
                                                            <th className="cpa-modal-table-th provider">{t('enw-input-provider')}</th>
                                                            <th className="cpa-modal-table-th amount">{t('enw-input-price')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredModalList.map((item, idx) => {
                                                            const isSelected = selectedProvider && item.provider && item.provider.trim().toLowerCase() === selectedProvider;
                                                            const isEnw = item.isEnw === true;
                                                            return (
                                                                <tr
                                                                    key={idx}
                                                                    className={
                                                                        "cpa-modal-table-row" +
                                                                        (item.provider === modalProvider && idx !== 0 ? " d-none" : item.provider.trim().toLowerCase() === subProviders.trim().toLowerCase() ? " selected" : "") +
                                                                        (isSelected ? " filtered-provider-row" : "") +
                                                                        (isEnw ? " enw-provider-row" : "")
                                                                    }
                                                                >
                                                                    <td
                                                                        className={
                                                                            "cpa-modal-table-td provider" +
                                                                            (isSelected ? " filtered-provider-td" : "")
                                                                        }
                                                                        style={isEnw ? { background: "#e8f5e9", fontWeight: 700, borderLeft: "4px solid #43a047" } : isSelected ? { background: "#e3f2fd" } : {}}
                                                                    >
                                                                        {idx + 1 + ". "}{item.provider} {isEnw && <span style={{ fontSize: 11, color: '#388e3c' }}></span>}
                                                                    </td>
                                                                    <td className="cpa-modal-table-td amount" style={isEnw ? { background: "#e8f5e9", fontWeight: 700 } : {}}>
                                                                        {formatAmountWithDot(item.amount)} <span className="cpa-modal-table-currency">{item.currencyCode}</span>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div style={{ fontSize: "16px", fontWeight: "500" }}>{t('enw-cpa-data_not_found')}</div>
                                            )}
                                        </DialogContent>
                                        <DialogActions>
                                            <ButtonAtm
                                                className="m-auto cpa-modal-close-btn bg-red"
                                                buttontext={t('btn-close')}
                                                onClick={() => setModalOpen(false)}
                                                autoFocus
                                                color="primary"
                                            />
                                        </DialogActions>
                                    </Dialog>
                                </>
                                :
                                <></>
                        }
                    </>
            }
        </>
    )
}

export default CompetitorAnalysisAdvanced;